import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { NgxPermissionsService } from 'ngx-permissions';

@Injectable()
export class RoleGuard {
  constructor(
    private permissionService: NgxPermissionsService,
    private router: Router,
    private authService: AuthService
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (next.data.permission === 'view_admin') {
      if (next.url.length === 0) {
        this.router.navigate([`/dashboard`]);
      }
      return true;
    }

    console.log(this.permissionService.getPermissions());
    console.log('Has Permission: ', next.data.permission_name, ' ' + this.authService.hasPermission(next.data.permission));

    if (!next.data.permission) {
      return true;
    }

    console.log(this.permissionService.getPermissions());
    if (!this.authService.hasPermission(next.data.permission)) {
      console.warn('Access Denied. Navigated to default route');
      this.router.navigate([`/mobile`]);
      return false;
    }

    else if (this.permissionService.hasPermission(next.data.permission)) {
      return true;
    }

    else {
      console.log(`Permission/Role not recognized`);
      return false;
    }
  }

}
